import React from 'react';
import { useRealtime } from '../contexts/RealtimeContext';
import { 
  WifiIcon, 
  ExclamationTriangleIcon, 
  CheckCircleIcon,
  XCircleIcon
} from '@heroicons/react/24/outline';

const RealtimeStatus: React.FC = () => {
  const { isConnected, connectionStatus, lastEvent, eventCount } = useRealtime();

  const getStatusIcon = () => {
    switch (connectionStatus) {
      case 'connected':
        return <CheckCircleIcon className="h-4 w-4 text-green-500" />;
      case 'connecting':
        return <WifiIcon className="h-4 w-4 text-yellow-500 animate-pulse" />;
      case 'disconnected':
        return <XCircleIcon className="h-4 w-4 text-red-500" />;
      case 'error':
        return <ExclamationTriangleIcon className="h-4 w-4 text-red-500" />;
      default:
        return <WifiIcon className="h-4 w-4 text-gray-400" />;
    }
  };

  const getStatusText = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'Connected';
      case 'connecting':
        return 'Connecting...';
      case 'disconnected':
        return 'Disconnected';
      case 'error':
        return 'Error';
      default:
        return 'Unknown';
    }
  };

  const getStatusColor = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'text-green-600';
      case 'connecting':
        return 'text-yellow-600';
      case 'disconnected':
        return 'text-red-600';
      case 'error':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg">
      {getStatusIcon()}
      <span className={`text-sm font-medium ${getStatusColor()}`}>
        {getStatusText()}
      </span>
      {eventCount > 0 && (
        <span className="text-xs text-gray-500">
          ({eventCount} events)
        </span>
      )}
      {lastEvent && (
        <span className="text-xs text-gray-400 truncate max-w-32">
          Last: {lastEvent.replace('_', ' ')}
        </span>
      )}
    </div>
  );
};

export default RealtimeStatus;
